/* Sophies Label - Find My Size. Rendered by snippets/sl-fit-finder.liquid */
(function () {
  'use strict';
  if (window.__slFitFinder) return;
  window.__slFitFinder = true;

  // Average US women's ready-to-wear weight (lbs) per US size.
  var US_BY_WEIGHT = [[0,105],[2,115],[4,125],[6,132],[8,140],[10,148],[12,158],[14,170],[16,185],[18,200],[20,215],[22,230],[24,245]];
  // Used only when the chart has no US column: estimated bust (in) to letter size.
  var LETTER_BY_BUST = [['XS',0,32.5],['S',32.5,34.5],['M',34.5,36.5],['L',36.5,39],['XL',39,41.5],['2XL',41.5,44],['3XL',44,999]];
  var ALIAS = { XXS: '2XS', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' };
  var IMPERIAL_COUNTRIES = ['US', 'LR', 'MM'];

  var root = null;
  var trigger = null;
  var s = null;

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function canon(v) {
    var k = String(v == null ? '' : v).toUpperCase().trim();
    return ALIAS[k] || k;
  }
  function usRange(v) {
    var nums = String(v == null ? '' : v).split('(')[0].match(/\d+(\.\d+)?/g);
    if (!nums) return null;
    var a = parseFloat(nums[0]);
    var b = nums.length > 1 ? parseFloat(nums[1]) : a;
    return [Math.min(a, b), Math.max(a, b)];
  }

  // The size chart that sits next to the link is the single source of truth.
  function readChart(selector) {
    var modal = selector ? document.querySelector(selector) : null;
    var table = modal ? modal.querySelector('table.sizing-chart-table') : null;
    if (!table) return null;
    var cells = function (tr, tag) {
      return [].map.call(tr.querySelectorAll(tag), function (c) { return c.textContent.trim(); });
    };
    var headRow = table.querySelector('thead tr');
    if (!headRow) return null;
    var headers = cells(headRow, 'th').map(function (h) { return h.toLowerCase(); });
    var usCol = -1, sizeCol = -1;
    headers.forEach(function (h, i) {
      if (usCol < 0 && /(^|[^a-z])us([^a-z]|$)/.test(h)) usCol = i;
      else if (sizeCol < 0 && h.indexOf('size') !== -1) sizeCol = i;
    });
    if (sizeCol < 0) return null;
    var rows = [];
    [].forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
      var c = cells(tr, 'td');
      if (c[sizeCol]) rows.push({ size: c[sizeCol], us: usCol >= 0 ? usRange(c[usCol]) : null });
    });
    return rows.length ? rows : null;
  }

  // The same table, for showing in the Size Chart tab. The US column stays in use for
  // the recommendation but is not displayed; the unit moves from the headers to the caption.
  function readTable(selector) {
    var modal = selector ? document.querySelector(selector) : null;
    var table = modal ? modal.querySelector('table.sizing-chart-table') : null;
    var headRow = table && table.querySelector('thead tr');
    if (!headRow) return null;
    var text = function (c) { return c.textContent.trim(); };
    var raw = [].map.call(headRow.querySelectorAll('th'), text);
    var keep = [];
    raw.forEach(function (h, i) { if (!/(^|[^a-z])us([^a-z]|$)/i.test(h)) keep.push(i); });
    var rows = [];
    [].forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
      var cells = [].map.call(tr.querySelectorAll('td'), text);
      if (cells.length) rows.push(keep.map(function (i) { return cells[i] || ''; }));
    });
    if (!rows.length) return null;
    return {
      headers: keep.map(function (i) { return raw[i].replace(/\s*\(.*?\)\s*/g, ''); }),
      rows: rows,
      unit: /\(cm\)/i.test(raw.join(' ')) ? 'centimeters' : 'inches'
    };
  }

  function sizeSteps(st) {
    var n = 0;
    if (st.fit === 'loose') n += 1; else if (st.fit === 'tight') n -= 1;
    if (st.bust === 'fuller') n += 0.5; else if (st.bust === 'smaller') n -= 0.5;
    if (st.waist === 'curvier') n += 0.5; else if (st.waist === 'flatter') n -= 0.5;
    if (st.hips === 'wider') n += 0.5; else if (st.hips === 'narrow') n -= 0.5;
    return n;
  }

  function recommend(st) {
    var sold = st.sizes;
    var soldCanon = sold.map(canon);
    var rows = (st.chart || []).filter(function (r) { return soldCanon.indexOf(canon(r.size)) !== -1; });
    var steps = sizeSteps(st);
    var withUs = rows.filter(function (r) { return r.us; });

    if (withUs.length) {
      var us = US_BY_WEIGHT[0][0], best = Infinity;
      US_BY_WEIGHT.forEach(function (p) {
        var d = Math.abs(st.lbs - p[1]);
        if (d < best) { best = d; us = p[0]; }
      });
      us += steps * 2;
      var last = withUs[withUs.length - 1];
      var pick = null;
      withUs.some(function (r) {
        if (us >= r.us[0] - 0.5 && us <= r.us[1] + 0.5) { pick = r; return true; }
        return false;
      });
      if (!pick) {
        var gap = Infinity;
        withUs.forEach(function (r) {
          var d = Math.abs(us - (r.us[0] + r.us[1]) / 2);
          if (d <= gap) { gap = d; pick = r; } // a tie goes to the larger size
        });
      }
      return { size: pick.size, snug: pick === last && us > last.us[1] + 0.5 };
    }

    // No US column in this chart: estimate the bust and map it to the sold sizes.
    var order = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];
    var bust = 35 + ((st.lbs - 140) / 10) * 0.7 + ((st.inches - 66) / 2) * 0.3;
    var letter = LETTER_BY_BUST[LETTER_BY_BUST.length - 1][0];
    LETTER_BY_BUST.some(function (b) {
      if (bust >= b[1] && bust < b[2]) { letter = b[0]; return true; }
      return false;
    });
    var target = order.indexOf(letter) + Math.round(steps);
    var chosen = null, dist = Infinity, top = -1;
    sold.forEach(function (v) {
      var i = order.indexOf(canon(v));
      if (i < 0) return;
      if (i > top) top = i;
      var d = Math.abs(i - target);
      if (d <= dist) { dist = d; chosen = v; }
    });
    return chosen ? { size: chosen, snug: target > top } : null;
  }

  function dots(step) {
    var out = '';
    for (var i = 1; i <= 3; i++) out += '<div class="sl-ff-dot' + (step >= i ? ' is-on' : '') + '"></div>';
    return '<div class="sl-ff-dots">' + out + '</div>';
  }
  function tabs() {
    if (!s.table) return '';
    return '<div class="sl-ff-tabs">' +
      '<button type="button" class="sl-ff-tab' + (s.tab === 'finder' ? ' is-on' : '') + '" data-tab="finder">FIND MY SIZE</button>' +
      '<button type="button" class="sl-ff-tab' + (s.tab === 'chart' ? ' is-on' : '') + '" data-tab="chart">SIZE CHART</button>' +
      '</div>';
  }
  function head(title, sub) {
    return '<div class="sl-ff-head"><p class="sl-ff-eyebrow">Sophies Fit Finder</p>' +
      '<h2 class="sl-ff-title" id="sl-ff-title">' + esc(title) + '</h2>' + tabs() +
      (sub ? '<p class="sl-ff-sub">' + esc(sub) + '</p>' : '') + '</div>';
  }
  function chartView() {
    var t = s.table;
    return head('Size chart', 'Measurements in ' + t.unit + '. Between sizes? Size up.') +
      '<div class="sl-ff-table-wrap"><table class="sl-ff-table"><thead><tr>' +
      t.headers.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') +
      '</tr></thead><tbody>' +
      t.rows.map(function (r) {
        return '<tr>' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
      }).join('') +
      '</tbody></table></div>';
  }
  function input(id, placeholder, unit, value) {
    return '<div class="sl-ff-input"><input id="' + id + '" type="number" inputmode="numeric" placeholder="' + placeholder + '"' +
      (value ? ' value="' + esc(value) + '"' : '') + ' aria-label="' + unit + '"><span>' + unit + '</span></div>';
  }
  function opt(group, val, label) {
    return '<button type="button" class="sl-ff-opt' + (s[group] === val ? ' is-on' : '') + '" data-group="' + group + '" data-val="' + val + '">' + label + '</button>';
  }
  function shapeField(label, group, a, aLabel, b, bLabel) {
    return '<div class="sl-ff-field"><span class="sl-ff-label">' + label + '</span><div class="sl-ff-row sl-ff-row--tight">' +
      opt(group, a, aLabel) + opt(group, 'average', 'Average') + opt(group, b, bLabel) + '</div></div>';
  }
  function fitOpt(val, label, desc) {
    return '<button type="button" class="sl-ff-opt sl-ff-opt--fit' + (s.fit === val ? ' is-on' : '') + '" data-group="fit" data-val="' + val + '"><b>' + label + '</b><small>' + desc + '</small></button>';
  }

  // The variant that matches the shopper's current selection, in the given size.
  function findVariant(size) {
    var form = pickerScope();
    var current = [];
    s.optionNames.forEach(function (name, i) {
      if (i === s.sizeIndex) return;
      var input = form && form.querySelector('input[type="radio"][name="' + name.replace(/"/g, '\\"') + '"]:checked');
      var select = form && form.querySelector('select[name="options[' + name.replace(/"/g, '\\"') + ']"]');
      current[i] = input ? input.value : (select ? select.value : null);
    });
    var want = canon(size);
    return s.variants.filter(function (v) {
      if (canon(v.o[s.sizeIndex]) !== want) return false;
      return v.o.every(function (o, i) { return i === s.sizeIndex || current[i] == null || current[i] === o; });
    })[0] || null;
  }
  function pickerScope() { return trigger && trigger.closest('variant-selects, variant-radios') || document.querySelector('variant-selects, variant-radios'); }

  function render() {
    var c = '';
    var isChart = s.tab === 'chart' && s.table;
    if (isChart) {
      c = chartView();
    } else if (s.step === 1) {
      var imperial = s.unit === 'imperial';
      c = head("Let's find your size", 'Your data stays on your device.') +
        '<div class="sl-ff-units">' + opt('unit', 'imperial', 'ft / lbs').replace('sl-ff-opt', 'sl-ff-opt sl-ff-opt--unit') + opt('unit', 'metric', 'cm / kg').replace('sl-ff-opt', 'sl-ff-opt sl-ff-opt--unit') + '</div>' +
        '<div class="sl-ff-field"><span class="sl-ff-label">Height</span><div class="sl-ff-row">' +
        (imperial ? input('sl-ff-ft', '5', 'FT', s.ft) + input('sl-ff-in', '6', 'IN', s.in) : input('sl-ff-cm', '168', 'CM', s.cm)) +
        '</div></div>' +
        '<div class="sl-ff-field"><span class="sl-ff-label">Weight</span><div class="sl-ff-row">' +
        input('sl-ff-wt', imperial ? '140' : '65', imperial ? 'LBS' : 'KG', imperial ? s.wtLbs : s.wtKg) +
        '</div></div>' +
        '<button type="button" class="sl-ff-btn sl-ff-btn--main" data-act="next1">CONTINUE</button>';
    } else if (s.step === 2) {
      c = head('Your shape', 'How would you describe your shape?') +
        shapeField('Waist / Belly', 'waist', 'flatter', 'Flatter', 'curvier', 'Curvier') +
        shapeField('Hips', 'hips', 'narrow', 'Narrow', 'wider', 'Wider') +
        shapeField('Bust', 'bust', 'smaller', 'Smaller', 'fuller', 'Fuller') +
        '<div class="sl-ff-actions"><button type="button" class="sl-ff-btn sl-ff-btn--back" data-act="to1">BACK</button><button type="button" class="sl-ff-btn sl-ff-btn--main" data-act="to3">CONTINUE</button></div>';
    } else if (s.step === 3) {
      c = head('Your fit preference', 'How do you like your clothes to fit?') +
        '<div class="sl-ff-row">' + fitOpt('tight', 'Tight', 'Body hugging') + fitOpt('regular', 'Regular', 'True to size') + fitOpt('loose', 'Loose', 'Relaxed fit') + '</div>' +
        '<div class="sl-ff-actions"><button type="button" class="sl-ff-btn sl-ff-btn--back" data-act="to2">BACK</button><button type="button" class="sl-ff-btn sl-ff-btn--main" data-act="to4">FIND MY SIZE</button></div>';
    } else {
      var rec = recommend(s);
      s.rec = rec;
      var v = rec ? findVariant(rec.size) : null;
      s.recVariant = v && v.a ? v : null;
      var notes = '';
      if (rec && rec.snug) notes += '<p class="sl-ff-note">' + esc(rec.size) + ' is our largest size, so based on your measurements it may fit a little snug.</p>';
      if (rec && v && !v.a) notes += '<p class="sl-ff-note">' + esc(rec.size) + ' is currently sold out in this color.</p>';
      c = head('Your size', '') + (rec
        ? '<div class="sl-ff-result"><p>Based on your measurements, we recommend</p><div class="sl-ff-size">' + esc(rec.size) + '</div><p>You can always adjust the size before checkout.</p>' + notes + '</div>'
        : '<div class="sl-ff-result"><p>We could not match a size for this product. Please check the size chart.</p></div>');
      c += '<div class="sl-ff-actions"><button type="button" class="sl-ff-btn sl-ff-btn--back" data-act="to3">BACK</button>' +
        (s.recVariant
          ? '<button type="button" class="sl-ff-btn sl-ff-btn--main" data-act="add">ADD ' + esc(rec.size) + ' TO CART</button>'
          : '<button type="button" class="sl-ff-btn sl-ff-btn--main" data-act="close">GOT IT</button>') +
        '</div>';
    }
    root.innerHTML = '<div class="sl-ff-bg" data-act="close"></div>' +
      '<div class="sl-ff-modal' + (isChart ? ' is-chart' : '') + '" role="dialog" aria-modal="true" aria-labelledby="sl-ff-title" tabindex="-1">' +
      '<button type="button" class="sl-ff-close" data-act="close" aria-label="Close">&times;</button>' +
      (isChart ? '' : dots(s.step === 4 ? 3 : s.step)) + c + '</div>';
  }

  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }

  function keepInputs() {
    if (s.unit === 'imperial') { s.ft = val('sl-ff-ft'); s.in = val('sl-ff-in'); s.wtLbs = val('sl-ff-wt'); }
    else { s.cm = val('sl-ff-cm'); s.wtKg = val('sl-ff-wt'); }
  }
  // Empty fields fall back to the shown example values.
  function readBody() {
    keepInputs();
    if (s.unit === 'imperial') {
      s.inches = (parseInt(s.ft, 10) || 5) * 12 + (parseInt(s.in, 10) || (s.in === '0' ? 0 : 6));
      s.lbs = parseInt(s.wtLbs, 10) || 140;
    } else {
      s.inches = (parseInt(s.cm, 10) || 168) / 2.54;
      s.lbs = Math.round((parseInt(s.wtKg, 10) || 65) * 2.205);
    }
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    if (trigger && trigger.isConnected) trigger.focus();
  }

  function addFallback(id) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (r.ok) window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
    });
  }

  // Select the size on the page, wait for the theme to switch variant, then use its
  // own add-to-cart button. Never submits unless the form holds the recommended variant.
  function addToCart(variant, size) {
    var scope = pickerScope();
    var value = variant.o[s.sizeIndex];
    var name = s.optionNames[s.sizeIndex];
    var radio = scope && [].filter.call(scope.querySelectorAll('input[type="radio"]'), function (i) {
      return i.name === name && i.value === value;
    })[0];
    if (radio && !radio.checked) radio.click();
    var info = (scope && scope.closest('product-info')) || document.querySelector('product-info');
    var form = info && info.querySelector('product-form form[action*="/cart/add"]');
    var started = Date.now();
    (function wait() {
      form = info && info.querySelector('product-form form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var button = form && form.querySelector('button[type="submit"], .product-form__submit');
      if (idInput && String(idInput.value) === String(variant.id) && button && !button.disabled) { button.click(); return; }
      if (Date.now() - started > 4000) { addFallback(variant.id); return; }
      setTimeout(wait, 80);
    })();
  }

  function onRootClick(e) {
    var el = e.target.closest('[data-act], [data-group], [data-tab]');
    if (!el) return;
    var tab = el.getAttribute('data-tab');
    if (tab) {
      if (s.tab === 'finder' && s.step === 1) keepInputs();
      s.tab = tab;
      render();
      return;
    }
    var group = el.getAttribute('data-group');
    if (group) {
      if (group === 'unit') { keepInputs(); s.unitTouched = true; }
      s[group] = el.getAttribute('data-val');
      render();
      return;
    }
    var act = el.getAttribute('data-act');
    if (act === 'close') return close();
    if (act === 'next1') { readBody(); s.step = 2; return render(); }
    if (act === 'to1') { s.step = 1; return render(); }
    if (act === 'to2') { s.step = 2; return render(); }
    if (act === 'to3') { s.step = 3; return render(); }
    if (act === 'to4') { s.step = 4; return render(); }
    if (act === 'add' && s.recVariant) {
      var v = s.recVariant, size = s.rec.size;
      close();
      addToCart(v, size);
    }
  }

  function applyVisitorUnit() {
    function apply(cc) {
      if (!cc || !s || s.step !== 1 || s.tab !== 'finder' || s.unitTouched) return;
      var unit = IMPERIAL_COUNTRIES.indexOf(cc) !== -1 ? 'imperial' : 'metric';
      if (unit === s.unit || val('sl-ff-wt') || val('sl-ff-cm') || val('sl-ff-ft')) return;
      s.unit = unit;
      render();
    }
    var cached = null;
    try { cached = sessionStorage.getItem('sl_ff_cc'); } catch (err) {}
    if (cached) return apply(cached);
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!cc) return;
        cc = String(cc).toUpperCase();
        try { sessionStorage.setItem('sl_ff_cc', cc); } catch (err) {}
        apply(cc);
      })
      .catch(function () {});
  }

  function open(link) {
    trigger = link;
    var variants = [];
    try { variants = JSON.parse(link.getAttribute('data-variants') || '[]'); } catch (err) {}
    var sizeIndex = parseInt(link.getAttribute('data-size-index'), 10);
    var sizes = [];
    variants.forEach(function (v) {
      var val = v.o[sizeIndex];
      if (sizes.indexOf(val) === -1) sizes.push(val);
    });
    var scope = pickerScope();
    var optionNames = [];
    if (scope) {
      // Option names in order, from the theme's own picker. The size position comes from Liquid.
      [].forEach.call(scope.querySelectorAll('input[type="radio"], select'), function (el) {
        var n = el.tagName === 'SELECT' ? el.name.replace(/^options\[|\]$/g, '') : el.name;
        if (n && optionNames.indexOf(n) === -1) optionNames.push(n);
      });
    }
    s = {
      step: 1, unit: 'imperial', unitTouched: false,
      ft: '', in: '', wtLbs: '', cm: '', wtKg: '',
      waist: 'average', hips: 'average', bust: 'average', fit: 'regular',
      tab: 'finder',
      chart: readChart(link.getAttribute('data-chart')),
      table: readTable(link.getAttribute('data-chart')),
      variants: variants, sizes: sizes, sizeIndex: sizeIndex, optionNames: optionNames
    };
    if (!root) {
      root = document.createElement('div');
      root.id = 'sl-ff-root';
      root.addEventListener('click', onRootClick);
      document.body.appendChild(root);
    }
    render();
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    applyVisitorUnit();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sl-ff-open]');
    if (!link) return;
    e.preventDefault();
    open(link);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
  });
})();
